<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-membership v-model="filter" @filter="onFilter()"></filter-membership>
			</v-flex>
			<v-flex xs12>
				<app-datatable :title="$t('title.memberships_datatable')" :printUrl="$route('central.memberships.print.memberships', {
					code: this.filter.code,
					name: this.filter.name,
					price: this.filter.price,
				})
					" :endpoint="endpoint" :data="data" :headers="headers" :filter="filter" @onPrint="printItem" @onEdit="editItem" @onDelete="deleteItem" @onView="viewItem" :hasView="$gates.hasAnyPermission('view memberships')"
					:hasEdit="$gates.hasAnyPermission('edit memberships')" :hasDelete="$gates.hasAnyPermission('delete memberships')" sortOrder>
					<template v-slot:[`item.image`]="{ item }">
						<v-img :src="item.sample_card_url" :lazy-src="item.sample_card_url" :aspect-ratio="4 / 3" contain width="100" height="75"></v-img>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button v-model="item.active"></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button v-permission="'create memberships'" @click="$inertia.visit($route('central.memberships.create'))"></app-create-fab-button>

		<app-delete-dialog ref="deleteDialog" :endpoint="'central.memberships.destroy'" :uuid="item.uuid"></app-delete-dialog>
	</v-container>
</template>

<script>
	import pickBy from "lodash/pickBy";
	export default {
		props: ["data"],
		data() {
			return {
				filter: {},
				item: {},
			};
		},
		computed: {
			endpoint() {
				return this.$route("central.memberships.index");
			},
			headers() {
				return [
					{
						text: this.$t("Action"),
						value: "actions",
						sortable: false,
						searchable: false,
						align: "left",
						width: 80,
					},
					{
						text: this.$t("Image"),
						value: "image",
						sortable: false,
						searchable: false,
						width: 80,
					},
					{
						text: this.$t("Code"),
						value: "code",
						align: "start",
						sortable: false,
					},
					{
						text: this.$t("Name"),
						value: "name",
						sortable: false,
						searchable: false,
						width: 200,
					},
					{
						text: this.$t("Price"),
						value: "price",
						searchable: false,
						sortable: false,
						width: 120,
					},
					{
						text: this.$t("label.bonus"),
						value: "bonus",
						searchable: false,
						sortable: false,
						width: 120,
					},
					{
						text: this.$t("label.features"),
						value: "features_count",
						searchable: false,
						sortable: false,
					},
					{
						text: this.$t("label.subscriptions"),
						value: "subscriptions_count",
						searchable: false,
						sortable: false,
					},
					{
						text: this.$t("Sort Order"),
						value: "sort_order",
						sortable: false,
						searchable: false,
						width: 120,
						align: "center",
					},
					{
						text: this.$t("Active"),
						value: "active",
						sortable: false,
						searchable: false,
						width: 80,
						align: "right",
					},
				];
			},
		},

		methods: {
			onFilter() {
				var filter = pickBy(this.filter);
				this.$inertia.get(
					this.endpoint,
					{ filter },
					{
						preserveState: true,
						preserveScroll: true,
					}
				);
			},
			editItem(item) {
				this.$inertia.get(
					this.$route("central.memberships.edit", item.uuid)
				);
			},

			viewItem(item) {
				this.$inertia.get(
					this.$route("central.memberships.show", item.uuid)
				);
			},
			deleteItem(item) {
				this.item = Object.assign({}, item);
				this.$refs.deleteDialog.open();
			},
			printItem(item) {
				window.open(
					this.$route("central.print.membership", {
						membership: item.uuid,
					})
				);
			},
		},
	};
</script>